var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 55,
    viewBox: "0 0 47 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7286 21.8529C31.8924 21.0763 31.833 20.2692 31.5571 19.5249C31.2813 18.7807 30.8003 18.1298 30.1699 17.6476C29.7831 17.3475 29.3458 17.1191 28.8785 16.9731L27.4474 16.5341C27.1134 16.4315 26.7625 16.3958 26.4148 16.429C26.067 16.4622 25.7292 16.5636 25.4206 16.7274C25.112 16.8912 24.8388 17.1142 24.6164 17.3837C24.3941 17.6532 24.2271 17.9638 24.1249 18.2979L21.8703 25.6722C21.7676 26.0061 21.7318 26.3569 21.7649 26.7047C21.798 27.0524 21.8993 27.3902 22.0632 27.6987C22.227 28.0072 22.4501 28.2803 22.7197 28.5025C22.9893 28.7246 23.3 28.8914 23.6341 28.9933L25.1017 29.449C25.4954 29.5708 25.9051 29.6328 26.3171 29.6329C27.2103 29.6316 28.0797 29.345 28.7985 28.8147C29.5172 28.2845 30.0478 27.5385 30.3127 26.6856L31.0282 24.3672C31.1954 23.8628 31.3321 23.3387 31.4734 22.8176C31.5174 22.655 31.5706 22.497 31.6116 22.333C31.6405 22.2236 31.6785 22.1187 31.7058 22.0094C31.7195 21.9531 31.718 21.903 31.7286 21.8529Z",
    fill: "#595DC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89595 21.852C3.90659 21.9022 3.90507 21.9508 3.91722 22.004C3.94457 22.1149 3.98255 22.2166 4.00989 22.326C4.05091 22.4871 4.10257 22.6375 4.14511 22.7955C4.29703 23.3211 4.42768 23.8589 4.59176 24.3512L5.31036 26.6801C5.57572 27.5323 6.10626 28.2775 6.82469 28.8071C7.54312 29.3367 8.41188 29.623 9.30441 29.6244C9.71646 29.6243 10.1262 29.5624 10.5198 29.4406L11.9859 28.9848C12.3201 28.8833 12.6309 28.7168 12.9007 28.4948C13.1704 28.2729 13.3936 27.9999 13.5577 27.6915C13.7217 27.3831 13.8232 27.0454 13.8564 26.6977C13.8896 26.35 13.8539 25.9992 13.7512 25.6653L11.4997 18.2955C11.3973 17.9616 11.2302 17.6511 11.0078 17.3818C10.7854 17.1125 10.5121 16.8896 10.2036 16.7259C9.89501 16.5623 9.55723 16.461 9.20953 16.428C8.86183 16.3949 8.51102 16.4307 8.17714 16.5332L6.74603 16.9707C6.27907 17.1174 5.84184 17.3458 5.45468 17.6453C4.82441 18.128 4.34357 18.7791 4.06775 19.5235C3.79192 20.2679 3.73236 21.0752 3.89595 21.852Z",
    fill: "#595DC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.7287 21.8526C32.307 19.55 32.6079 17.1865 32.625 14.8125C32.625 10.884 31.0644 7.11636 28.2865 4.33848C25.5086 1.5606 21.741 0 17.8125 0C13.884 0 10.1164 1.5606 7.33848 4.33848C4.5606 7.11636 3 10.884 3 14.8125C3.01706 17.1865 3.31798 19.55 3.89635 21.8526C3.73276 21.0758 3.79231 20.2685 4.06814 19.5241C4.34397 18.7797 4.8248 18.1285 5.45508 17.6459C5.34439 16.7054 5.28556 15.7595 5.27885 14.8125C5.27885 11.4884 6.59935 8.30038 8.94987 5.94987C11.3004 3.59935 14.4884 2.27885 17.8125 2.27885C21.1366 2.27885 24.3246 3.59935 26.6751 5.94987C29.0256 8.30038 30.3462 11.4884 30.3462 14.8125C30.3395 15.76 30.2806 16.7064 30.1699 17.6474C30.8004 18.1296 31.2813 18.7805 31.5572 19.5247C31.833 20.2689 31.8925 21.076 31.7287 21.8526Z",
    fill: "url(#paint0_linear_245_93748)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4494 24.6353L9.28978 21.3909C9.21289 21.1758 9.22461 20.9389 9.32235 20.7325C9.42009 20.526 9.59586 20.3668 9.81097 20.2899C10.0261 20.213 10.2629 20.2247 10.4694 20.3225C10.6759 20.4202 10.8351 20.596 10.912 20.8111L12.0716 24.0555C12.1485 24.2706 12.1368 24.5075 12.039 24.7139C11.9413 24.9204 11.7655 25.0796 11.5504 25.1565C11.3353 25.2334 11.0985 25.2217 10.892 25.1239C10.6855 25.0262 10.5263 24.8504 10.4494 24.6353Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9119 24.6353L26.0715 21.3909C26.1484 21.1758 26.1367 20.9389 26.039 20.7325C25.9412 20.526 25.7655 20.3668 25.5504 20.2899C25.3352 20.213 25.0984 20.2247 24.8919 20.3225C24.6854 20.4202 24.5262 20.596 24.4493 20.8111L23.2897 24.0555C23.2128 24.2706 23.2245 24.5075 23.3223 24.7139C23.42 24.9204 23.5958 25.0796 23.8109 25.1565C24.026 25.2334 24.2629 25.2217 24.4694 25.1239C24.6758 25.0262 24.835 24.8504 24.9119 24.6353Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_93748)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_245_93748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3845 34.141C25.8033 32.4025 24.9504 30.123 25.0022 27.7735C25.0022 21.6651 29.9257 18 35.9975 18C42.0693 18 46.9927 21.6651 46.9927 27.7735C46.9927 33.882 42.0693 37.5471 35.9975 37.5471C34.5063 37.5562 33.024 37.3167 31.6116 36.8385C29.9745 38.5855 27.299 38.8176 25.5642 38.7565C25.4473 38.7513 25.3347 38.711 25.241 38.641C25.1473 38.5709 25.0768 38.4743 25.0386 38.3637C25.0004 38.2532 24.9963 38.1336 25.0269 38.0207C25.0574 37.9078 25.1212 37.8066 25.2099 37.7303C26.3547 36.8448 27.1297 35.5657 27.3845 34.141Z",
    fill: "#C99FFF",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.0215 28.9951C35.6975 28.9968 35.3861 28.8696 35.1559 28.6416C34.9256 28.4137 34.7954 28.1036 34.7937 27.7796C34.7921 27.4555 34.9193 27.1442 35.1473 26.9139C35.3752 26.6836 35.6853 26.5534 36.0093 26.5518H36.0215C36.3456 26.5518 36.6563 26.6805 36.8854 26.9096C37.1145 27.1387 37.2432 27.4494 37.2432 27.7734C37.2432 28.0975 37.1145 28.4082 36.8854 28.6373C36.6563 28.8664 36.3456 28.9951 36.0215 28.9951ZM42.13 27.7734C42.13 27.4494 42.0013 27.1387 41.7722 26.9096C41.5431 26.6805 41.2323 26.5518 40.9083 26.5518H40.8961C40.655 26.5542 40.42 26.6279 40.2207 26.7636C40.0214 26.8993 39.8667 27.0909 39.7762 27.3143C39.6856 27.5378 39.6631 27.783 39.7116 28.0192C39.7601 28.2554 39.8774 28.4719 40.0488 28.6415C40.2201 28.8112 40.4378 28.9263 40.6744 28.9725C40.9111 29.0186 41.1561 28.9937 41.3786 28.9009C41.6011 28.8081 41.7912 28.6515 41.9249 28.4509C42.0586 28.2503 42.13 28.0146 42.13 27.7734ZM32.3565 27.7734C32.3565 27.4494 32.2278 27.1387 31.9986 26.9096C31.7695 26.6805 31.4588 26.5518 31.1348 26.5518H31.1226C30.8815 26.5542 30.6465 26.6279 30.4472 26.7636C30.2479 26.8993 30.0932 27.0909 30.0026 27.3143C29.912 27.5378 29.8896 27.783 29.9381 28.0192C29.9866 28.2554 30.1039 28.4719 30.2752 28.6415C30.4466 28.8112 30.6643 28.9263 30.9009 28.9725C31.1375 29.0186 31.3826 28.9937 31.6051 28.9009C31.8276 28.8081 32.0177 28.6515 32.1514 28.4509C32.2851 28.2503 32.3565 28.0146 32.3565 27.7734Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_93748",
    x: 0.91,
    y: 9.31,
    width: 46.0832,
    height: 44.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12.1,
    dy: 3.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_93748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_93748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_245_93748",
    x: 5,
    y: -2,
    width: 61.9932,
    height: 60.7646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_93748"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_93748",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_93748",
    x1: 16.5,
    y1: -6,
    x2: 18.2214,
    y2: 17.9841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B45C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenter);
export default __webpack_public_path__ + "static/media/CallCenter.03a0c2cd73ab8ca4074f2f659af29177.svg";
export { ForwardRef as ReactComponent };